<template>
  <section class="content">
    <!-- Default box -->
    <div
      class="card card-solid"
      :style="{ 'min-height': $store.state.screenHeight - 200 + 'px' }"
    >
      <div class="card-header pb-0">
        <div class="row">
          <div class="form-group row col-sm-4 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >ลูกค้าเริ่ม</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="begin_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="begin_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >ลูกค้าสุดท้าย</label
            >
            <div class="col-sm-8 pb-0">
              <a-select
                class="mr-sm-2 pb-0"
                show-search
                option-filter-prop="children"
                style="width: 100%"
                :filter-option="filterOption"
                v-model="end_code"
              >
                <a-select-option value="">
                  -- ไม่เลือก --
                </a-select-option>
                <a-select-option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >
                  {{ b.code }}/{{ b.name }}
                </a-select-option>
              </a-select>
              <!-- <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="end_code"
              >
                <option value="">-- ไม่เลือก --</option>
                <option
                  v-for="(b, i) in data_cus_list"
                  :key="'branch' + i"
                  :value="b.code"
                >{{ b.name }}</option>
              </select> -->
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right pb-0"
              >เลือกสาขา</label
            >
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="branch"
                @change="onSelectBranch(branch)"
              >
                <!-- <option value="0">-- ทุกสาขา --</option> -->
                <option
                  v-for="(b, i) in $store.state.branch_list"
                  :key="'branch' + i"
                  :value="b"
                  >{{ b.branch_name }}</option
                >
              </select>
            </div>
          </div>
          <!-- <div class="form-group row col-sm-4 pb-0">
            <label
              for="date"
              class="col-sm-4 col-form-label text-right pb-0"
            >เลือกจุดขาย</label>
            <div class="col-sm-8 pb-0">
              <select
                class="custom-select mr-sm-2 pb-0"
                id="Host"
                v-model="host"
              >
                <option value="0">-- ทุกจุดขาย --</option>
                <option
                  v-for="(h, i) in host_list"
                  :key="'host' + i"
                  :value="h"
                >{{ h.host_name }}</option>
              </select>
            </div>
          </div> -->
          <div class="form-group row col-sm-4 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right"
              >จากวันที่</label
            >
            <div class="col-sm-8">
              <a-date-picker
                v-model="startDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
          <div class="form-group row col-sm-4 pb-0">
            <label for="date" class="col-sm-4 col-form-label text-right"
              >ถึงวันที่</label
            >
            <div class="col-sm-8">
              <a-date-picker
                v-model="endDate"
                :format="'DD/MM/YYYY'"
                style="width: 100%;"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <!-- <div class="col-sm-2"></div> -->
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-success btn-block"
              @click="getReport"
            >
              <i class="fas fa-redo"></i> ประมวลผล
            </button>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/pdf/report_holding_cus_remain.php"
              method="POST"
              target="_blank"
            >
              <input type="hidden" name="date_start" v-model="startDate" />
              <input type="hidden" name="date_end" v-model="endDate" />
              <input type="hidden" name="data" v-model="form_data" />
              <button type="submit" class="btn btn-primary btn-block">
                <i class="far fa-file-pdf"></i> บันทึกเป็น PDF
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <form
              action="/static/excel/report_holding_cus_remain.php"
              method="POST"
              target="_blank"
            >
              <input type="hidden" name="date_start" v-model="startDate" />
              <input type="hidden" name="date_end" v-model="endDate" />
              <input type="hidden" name="data" v-model="form_data" />
              <button type="submit" class="btn btn-info btn-block">
                <i class="far fa-file-excel"></i> บันทึกเป็น Excel
              </button>
            </form>
          </div>
          <div class="col-sm-3">
            <!-- <form
              action="/static/excel/report_holding_cus_remain.php"
              method="POST"
              target="_blank"
            >
              <input type="hidden" name="date_start" v-model="startDate" />
              <input type="hidden" name="date_end" v-model="endDate" />
              <input type="hidden" name="data" v-model="form_data" /> -->
              <button
                type="button"
                class="btn btn-primary btn-block"
                @click="printAllHoldPDF(report_data)"
              >
                <i class="far fa-file-pdf"></i> ใบวางบิลทั้งหมด
              </button>
            <!-- </form> -->
          </div>
        </div>
        <div class="text-center pt-3" v-if="report_data.length < 1">
          <h5>ไม่มีข้อมูล</h5>
        </div>
        <div
          class="table-responsive-sm mt-3"
          v-for="(c, i) in report_data"
          :key="'c' + i"
          v-show="c.pay_bill.length > 0"
        >
          <h4 class="m-1 p-1">สาขา: {{ c.branch_name || "-" }}</h4>
          <div
            id="sendMoney"
            class="table table-bordered"
            v-for="(cus_d, i) in c.pay_bill"
            :key="'cus_d' + i"
          >
            <!-- <table
              id="sendMoney"
              class="table table-bordered"
            >
              <tr style="background: #ffc10782;">
                <th>ลูกค้า: {{ cus_d.ar_code }}/{{ cus_d.ar_name }}</th>
                <th>เบอร์: {{ cus_d.ar_telephone }}</th>
                <th>มูลค่ารวม: {{ cus_d.total_amount }}</th>
              </tr>
            </table> -->

            <table id="sendMoney" colspan="6" class="table table-bordered">
              <tr style="background: #ffc10782;">
                <th colspan="2">
                  ลูกค้า: {{ cus_d.ar_code }}/{{ cus_d.ar_name }}
                </th>
                <th colspan="2">เบอร์: {{ cus_d.ar_telephone }}</th>
                <th colspan="3">
                  <div
                    class="d-flex justify-content-between"
                    style="margin: 0.25rem 0.25rem 0.25rem"
                  >
                    <div>
                      มูลค่ารวม: {{ numberFormatDecimal(cus_d.total_amount) }}
                    </div>
                    <div>
                      <button
                        type="submit"
                        class="btn btn-primary btn-block p-0"
                        style="font-size: 0.875rem; padding: 0 0.25rem 0 0.25rem !important;"
                        @click="printHoldingPDF(cus_d)"
                      >
                        <i class="far fa-file-pdf"></i> ใบวางบิล
                      </button>
                    </div>
                  </div>
                </th>
              </tr>
              <tbody v-for="(d, i) in cus_d.invoice" :key="'d' + i">
                <tr style="background: #fffed4;">
                  <th colspan="2">เลขที่ใบพักบิล: {{ d.doc_no }}</th>
                  <th colspan="2">
                    วันที่: {{ dateFormatAndTime(d.doc_date) }}
                  </th>
                  <th colspan="3">
                    ส่วนลด: {{ numberFormatDecimal(d.discount_amount) }}
                  </th>
                </tr>
                <tr class="text-center" style="background: #ebf6ff;">
                  <th>บาร์โค้ด</th>
                  <th>รายละอียด</th>
                  <th>ราคาต่อหน่วย</th>
                  <th>จำนวน</th>
                  <th>ส่วนลด</th>
                  <th>รวม</th>
                  <th>แก้ไข</th>
                </tr>
                <tr v-for="(s, i) in d.sub" :key="'csub' + i">
                  <td>{{ s.item_barcode }}</td>
                  <td>{{ s.item_name }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.price) }}</td>
                  <td class="text-right">{{ numberFormatDecimal(s.qty) }}</td>
                  <td class="text-right">0.00</td>
                  <td class="text-right">
                    {{ numberFormatDecimal(s.price * s.qty) }}
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      class="btn btn-warning btn-sm"
                      style="padding: 0 0.25rem;
                      margin: 0.25rem;"
                      @click="
                        modal_active = true;
                        modal_title = `แก้ไขข้อมูลใบพักบิล : ${d.doc_no} `;
                        editHoldBild(s, d);
                      "
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">Remark: {{ d.description || "-" }}</td>
                  <td style="background: #ebf6ff;">
                    รวมพักบิล: {{ d.doc_no }}
                  </td>
                  <td class="text-right">
                    {{ numberFormatDecimal(calQTY(d.sub)) }}
                  </td>
                  <td class="text-right" style="background: #ffd5d4;">0.00</td>
                  <td class="text-right" style="background: #e2ffd4;">
                    {{ numberFormatDecimal(calAmount(d.sub)) }}
                  </td>
                  <td class="text-right" style="background: #e2ffd4;"></td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- <h5>รวมสาขา: {{ (c[0])? c[0]['branch_name'] || '-' : '-' }}: {{ numberFormatDecimal(calAmountBranch(c)) }} บาท</h5> -->
        </div>
        <table style="width: 100%;" v-if="calAmountBranchAll(report_data) > 0">
          <tr>
            <th
              style="background: #eeffeb; text-align: left;"
              class="pt-2 pl-2 pb-0"
            >
              <h5>
                รวมทุกสาขา:
                {{ numberFormatDecimal(calAmountBranchAll(report_data)) }} บาท
              </h5>
            </th>
          </tr>
        </table>

        <a-modal
          :title="modal_title"
          centered
          v-model="modal_active"
          @ok="save_modal"
          @cancel="close_modal"
        >
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >บาร์โค้ด</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="บาร์โค้ด...."
                v-model="data_edit.item_barcode"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >รายละเอียด</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="รายละเอียด...."
                v-model="data_edit.item_name"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="salePrice" class="col-sm-3 text-right col-form-label"
              >ราคาต่อหน่วย</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="salePrice"
                maxlength="8"
                placeholder="ราคาขาย...."
                v-model.number="item_amounts"
                v-on:keypress="NumbersOnly"
                @change="onPriceChange()"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="saleUnit" class="col-sm-3 text-right col-form-label"
              >จำนวน</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="saleUnit"
                maxlength="8"
                placeholder="จำนวน...."
                v-model.number="item_units"
                v-on:keypress="NumbersOnly"
                @change="onPriceChange()"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >ส่วนลด</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                placeholder="ส่วนลด...."
                value="0.00"
              />
            </div>
          </div>
          <div class="form-group row mb-1">
            <label for="vendor_name" class="col-sm-3 text-right col-form-label"
              >ราคารวม</label
            >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control"
                id="vendor_name"
                disabled="true"
                :value="numberFormatDecimal(item_amount * item_unit)"
              />
            </div>
          </div>
        </a-modal>

        <form
          action="/static/pdf/report_sale_holdbill.php"
          ref="printHolding"
          target="_blank"
          method="POST"
        >
          <input type="hidden" name="data" v-model="form_data" />
        </form>

        <form
          action="/static/pdf/report_sale_holdbill_all.php"
          ref="printHoldingAll"
          target="_blank"
          method="POST"
        >
          <input type="hidden" name="data" v-model="form_data" />
        </form>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import apiMain from "../services/service";
import api from "../services/service_report";
import apipos from "../services/service_pos";
import apiCenter from "../services/service_undefined";
import apiCus from "@/services/service_customer";

export default {
  data() {
    return {
      report_data: [],
      startDate: moment(new Date()),
      data_edit: {},
      data_edit_pay: {},
      endDate: moment(new Date()),
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      form_data: "",
      branch: 0,
      branchName: "",
      host_list: [],
      host: null,
      data_cus_list: [],
      begin_code: "",
      end_code: "",
      dyn_address: "",
      modal_title: "",
      modal_active: false,
      item_amount:0.00,
      item_unit:0.00,
      item_sum:0.00
    };
  },
  computed: {
    item_amounts: {
      get: function() {
       if(this.item_amount !== '')
        return parseFloat(this.item_amount).toFixed(2)
      else
        return parseFloat(0).toFixed(2)
      },
      set: function(newValue) {
        this.item_amount = newValue
      }
    },
    item_units: {
      get: function() {
        if(this.item_unit !== '')
          return parseFloat(this.item_unit).toFixed(2)
        else
          return parseFloat(0).toFixed(2)
      },
      set: function(newValue) {
        this.item_unit = newValue
      }
    }
  },
  methods: {
    onSelectBranch(val) {
      this.dyn_address = val.dyn_address;
      this.getCus();
    },
    onUnitSelect(val) {},
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    editHoldBild(e, d) {
      this.data_edit = e;
      this.item_amount = e.price;
      this.item_unit = e.qty;
      this.item_sum =  parseFloat(this.item_amount) * parseFloat(this.item_unit);
      this.data_edit_pay = d;
    },
    saveHoldBild(e) {},
    onPriceChange() {
      // this.data_edit.sub = this.data_edit.amount-this.data_edit.amount;
      // this.data_edit.amount =
      //   parseFloat(this.data_edit.price) * parseFloat(this.data_edit.qty);
      this.item_sum = parseFloat(this.item_amount) * parseFloat(this.item_unit);
      // this.item_unit = this.item_unit.toFixed(2);

      // this.data_edit.sub += this.data_edit.amount;
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    getReport() {
      var branch = 0;
      this.report_data = [];
      this.form_data = "";
      if (this.branch !== 0) {
        branch = this.branch.id;
      }
      var obj = {
        id: branch,
        begin_date: this.dateDMY(this.startDate),
        end_date: this.dateDMY(this.endDate),
        // begin_date: '2020-08-01',
        // end_date: '2020-09-01',
        company_id: 1,
        branch_id: 1,
        // begin_code: '0236',
        // end_code: '0236',
        begin_code: this.begin_code,
        end_code: this.end_code,
        keyword: ""
      };
      this.$store.state.isLoading = false;
      this.$store.commit("Loading");
      api.holdingByPaybill(
        sessionStorage.Url,
        this.header,
        obj,
        result => {
          this.$store.state.isLoading = false;
         // this.$store.commit("Loading");
          if (result.response === "success") {
            this.report_data = result.data;
            this.form_data = JSON.stringify(this.report_data);
          } else {
            this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", result.message);
          }
        },
        error => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ดึงข้อมูลรายงานไม่ได้", error.message);
          this.$store.state.isLoading = false;
        }
      );
    },
    printAllHoldPDF(obj) {
      // console.log(obj)
      if (obj.length > 0) {


        this.$store.commit("Loading");
        apiCenter.branch(
        {
          branchName: this.branch.branch_name
        },
        this.header,
        results => {
          if (results.data.success.length > 0) {
            obj[0]["bank_account"] =
              "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " +
              results.data.success[0].def_account_code;
            // this.$store.commit("Loading");
            // console.log(obj)
            this.form_data = JSON.stringify(obj);
            setTimeout(() => {
              this.$refs.printHoldingAll.submit();
              this.$store.commit("Loading");
            }, 1000);
          }
        },
        errors => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );


        // this.$store.commit("Loading");
        // this.form_data = JSON.stringify(obj);
        // setTimeout(() => {
        //   this.$refs.printHoldingAll.submit();
        //   this.$store.commit("Loading");
        // }, 1000);
      }
    },
    printHoldingPDF(obj) {
      // console.log(this.branch.branch_name);
      obj["branch_name"] = this.report_data[0].branch_name;
      obj["branch_address"] = this.report_data[0].branch_address;
      obj["branch_telephone"] = this.report_data[0].branch_telephone;
      obj["company_name"] = this.report_data[0].company_name;
      obj["tax_id"] = this.report_data[0].tax_id;
      apiCenter.branch(
        {
          branchName: this.branch.branch_name
        },
        this.header,
        results => {
          if (results.data.success.length > 0) {
            obj["bank_account"] =
              "ชื่อบัญชี บริษัท แม่ริมอินเตอร์ฟูดส์ จำกัด ไทยพาณิชย์ เลขที่บัญชี " +
              results.data.success[0].def_account_code;
            this.$store.commit("Loading");
            console.log(obj)
            this.form_data = JSON.stringify(obj);
            setTimeout(() => {
              this.$refs.printHolding.submit();
              this.$store.commit("Loading");
            }, 1000);
          }
        },
        errors => {
          this.$store.commit("Loading");
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", errors.message);
        }
      );
    },
    save_modal() {

      this.data_edit.price = parseFloat(this.item_amount).toFixed(2);
      this.data_edit.qty = parseFloat(this.item_unit).toFixed(2);
      this.data_edit.amount = parseFloat(this.item_sum).toFixed(2);
      console.log(this.data_edit.amount);
      // this.data_edit.amount =
      //   parseFloat(this.data_edit.price) * parseFloat(this.data_edit.qty);

      apiCenter.updateSale(
        {
          branchName: this.branch.branch_name,
          data: this.data_edit
        },
        this.header,
        result => {
          this.modal_active = false;
          this.alert_msg("success", "บันทึกข้อมูลสำเร็จ", result.message);
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    close_modal() {
      this.modal_active = false;
    },
    timeFormat(str) {
      return moment(str).format("HH:mm:ss");
    },
    editVendor(data) {
      this.modal_title = "แก้ไขข้อมูลใบพักบิล : ";

      $("#modal_active").modal("show");
      // this.modal_data = data
    },
    getHost() {
      apipos.getHostShift(
        sessionStorage.Url,
        this.header,
        result => {
          if (result.response === "success") {
            this.host_list = result.data;
            this.host = this.host_list[0];
            // this.getReport()
          } else {
            this.alert_msg("warning", "ดึงข้อมูลจุดขายไม่ได้", result.message);
          }
        },
        error => {
          this.alert_msg("warning", "ไม่สามารถเข้าถึงข้อมูล", error.message);
        }
      );
    },
    calQTY(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["qty"];
      });
      return total;
    },
    calAmount(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["amount"];
      });
      return total;
    },
    calAmountBranch(obj) {
      var total = 0;
      obj.forEach(v => {
        total += v["total_amount"];
      });
      return total;
    },
    calAmountBranchAll(obj) {
      var total = 0;
      // obj.forEach(v => {
      //   v.forEach(val => {
      //     total += val['total_amount']
      //   })
      // })
      return total;
    },
    capEnter() {
      $("a").on("keyup", function(e) {
        if (e.which == 13) {
          console.log(e.target.href);
        }
      });
    },
    getCus() {
      this.$store.state.isLoading = true;
      let body = {
        keyword: "",
        limit: 100000,
        status: 1
      };
      apiMain.callMisApi(
        this.dyn_address + "/" + "customer/v1/list/customer",
        {
          headers: {
            "Access-Token": this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === "success") {
            this.data_cus_list = result.data;
          } else {
            this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", result.message);
          }
          this.$store.state.isLoading = false;
        },
        error => {
          this.alert_msg("warning", "ดึงข้อมูลลูกหนี้", error.message);
          this.$store.state.isLoading = false;
        }
      );
    }
  },
  mounted() {
    this.checkUser();
    this.getHost();
    this.getBranch();
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0];
      this.dyn_address = this.$store.state.branch_list[0].dyn_address;
      this.getCus();
    }, 500);
  }
};
</script>
<style scoped>
.head_table {
  background-color: #ffffad;
}
.head-branch {
  font-size: 18px;
  color: rgb(0, 0, 0);
  font-weight: bold;
}
.table .thead-dark th {
  color: #000000;
  background-color: #ffffad;
  border-color: #ffffad;
}
.table .thead-footer th {
  color: #000000;
  text-align: center;
  background-color: #ffff;
}
#sendMoney .table tr,
.table td,
.table th {
  padding: 0;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/views/report_holding_remain.vue